module.exports = __webpack_public_path__ + "img/cha.0e847c22.png";